import { ChangeDetectionStrategy, Component, ElementRef, inject, signal, ViewEncapsulation, WritableSignal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FaIconLibrary } from "@fortawesome/angular-fontawesome";
import { faEclipse, faGlobe, faKey, faMoon, faPowerOff, faSun } from "@fortawesome/pro-light-svg-icons";
import { HeaderChangePasswordDialogComponent } from "../change-password-dialog/change-password-dialog.component";
import { MatRippleModule } from "@angular/material/core";
import { MatMenuModule } from "@angular/material/menu";
import { IconModule } from "@ogs/ngx-m3-components";
import { AuthService } from "@features/authenticate/services/auth.service";
import { User } from "@features/authenticate/types/user";
import { ProfileInfoComponent } from "@shared/components/profile-info/profile-info.component";
import { UserAvatarComponent } from "@shared/components/user-avatar/user-avatar.component";
import { provideTranslationScope, TranslationPipeModule } from "@ogs-gmbh/ngx-translate";
import {
  LanguageSelectMenuItemComponent
} from "@shared/components/language-selection/components/language-select-menu-item/language-select-menu-item.component";

@Component({
  selector: "app-core-ui-header-dropdown-menu",
  templateUrl: "dropdown-menu.component.html",
  styleUrl: "dropdown-menu.component.scss",
  encapsulation: ViewEncapsulation.None,
  imports: [ MatRippleModule,
    MatMenuModule,
    IconModule,
    ProfileInfoComponent,
    UserAvatarComponent,
    TranslationPipeModule,
    LanguageSelectMenuItemComponent ],
  providers: [ provideTranslationScope("feature/secure") ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderDropdownMenuComponent {
  protected readonly dialog: MatDialog = inject(MatDialog);

  elementRef: ElementRef = inject(ElementRef);

  private readonly _authService: AuthService = inject(AuthService);


  public user: WritableSignal<User> = signal({} as User);

  isDesignMenuExpanded: boolean = false;

  private readonly faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  constructor () {
    this.faIconLibrary.addIcons(faMoon, faSun, faEclipse, faKey, faPowerOff, faGlobe);
    this._authService.getRegisteredUser().subscribe((user: User | undefined) => {
      if (user)
        this.user.set(user);
    });
  }

  onExpandDesign (mouseEvent: MouseEvent): void {
    this.isDesignMenuExpanded = !this.isDesignMenuExpanded;
    mouseEvent.stopPropagation();
  }

  isButtonVisible (): boolean {
    return this.isDesignMenuExpanded;
  }

  onResetMenu (): void {
    this.isDesignMenuExpanded = false;
  }

  onLogout (): void {
    this._authService.logout();
  }

  onChangePassword (): void {
    this.dialog.open(HeaderChangePasswordDialogComponent, {
      autoFocus: true,
      width: "528px"
    });
  }
}
